﻿'use strict';

/**
* Controller for the drop down menu
* @memberOf components.uiElements.dropDownMenuModule
* @namespace dropDownController
*/

dropDownController.$inject = ['$location'];

function dropDownController($location) {
    /* jshint validthis:true */
    var vm = this;
}

module.exports = dropDownController;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/uielements/dropdownmenu/dropDownController.js
// module id = 59
// module chunks = 0